import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import Switch from "react-switch";
import {
  tokens,
  success,
  alert,
  toFixed,
  GET,
  POST,
  PUT,
  float,
  validate,
  required,
  getStorage,
  format_date,
  DatePicker,
  loading,
} from "../../components/CustomComponent.js";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";

const create_r =
  getStorage("role_detail")?.find((i) => i.name === "manage-water")?.role[1] ===
  1;
const DAYS = ["", ...Array.from({ length: 31 }, (_, i) => i + 1)];
const MONTHS = ["", ...Array.from({ length: 12 }, (_, i) => i + 1)];

const toNum = (val) => Number(String(val).replace(/,/g, "")) || 0;

export default class ManageWater extends Component {
  state = {
    project_id: getStorage("project_id"),
    project_name: getStorage("project_name"),
    project_number: getStorage("project_number"),
    setting_water_id: getStorage("water_id"),
    payment_close_time: "",
    payment_duedate: "",
    meter_cut_date: "",
    meter_cut_month: "",
    interest_adjustment: 0.0,
    meter_convergence: 0.0,
    equipment_maintenance_fee: 0.0,
    common_expenses: 0.0,
    common_expenses_type: "0",
    waste_cost: 0.0,
    cable_cost: 0.0,
    add_debt: 0.0,
    reduce_debt: 0.0,
    payment_deadline: "",
    water_charge_start: 0.0,
    water_charge_end: 0.0,
    water_charge_price: 0.0,
    water_calculate_type: 2, // สูตรคำนวณค่าน้ำ 1 = ขั้นบันไดตั้งแต่ขั้นที่ 3 | 2 = ขั้นบันไดแท้ | 3 = เหมารวม
    // ล็อกช่องรูปแบบการคำนวณค่าน้ำ ต้องยืนยันสิทธิ์ก่อนถึงแก้ได้ (กลไกเดียวกับหน้า /record-receipt)
    editable_calculate_type: false,
    modal_permission: false,
    username: "",
    password: "",
    fire_month: "",
    fire_cost: 0.0,
    penalty_day_list: [""],
    penalty_month_list: [
      { month_start: "", month_end: "", penalty_year_rate: 0.0 },
    ],
    water_rate_list: [
      { water_rate_start: 0.0, water_rate_end: 0.0, water_rate_price: "0.00" },
    ],
    iw_number_text: "",
    rw_number_text: "",
    start_balance_statement: 0,
    start_date_statement: "",
    is_upload_slip: false,
    iw_running: "",
    rw_running: "",
    iw_status: false,
    rw_status: false,
    water_bill_text: "ค่าน้ำประปา",
    meter_connect_cost_text: "ค่าต่อมิเตอร์",
    equipment_maintenance_fee_text: "ค่าบริการอุปกรณ์",
    waste_cost_text: "ค่าขยะ",
    common_expenses_text: "ค่าส่วนกลาง",
    fire_cost_text: "ค่าเบี้ยประกัน",
    cable_cost_text: "ค่าเคเบิล",
  };

  async componentDidMount() {
    loading(true);
    await Promise.all([
      this.GetById(),
      this.GetDocNumber("IW"),
      this.GetDocNumber("RW"),
    ]);
    loading(false);
  }

  GetDocNumber = async (type) => {
    let r = await GET(
      tokens,
      `v1/TH/record-receipt/running-iw/${getStorage("project_id")}`,
      { format_doc: type },
    );
    if (r?.status && r.data.data) {
      this.setState(
        type === "IW"
          ? { iw_number_text: r.data.data.slice(0, -4) }
          : { rw_number_text: r.data.data.slice(0, -2) },
      );
    }
  };

  GetById = async () => {
    let r = await GET(
      tokens,
      `v1/TH/water-manage/detail/${this.state.setting_water_id}`,
      null,
    );
    if (r?.status) {
      let d = r.data.data;
      this.setState({
        ...d,
        iw_status: !!d.iw_running,
        rw_status: !!d.rw_running,
        iw_running: d.iw_running?.slice(-4) || "",
        rw_running: d.rw_running?.slice(-2) || "",
        iw_number_text: `IW${d.project_number}${format_date(
          new Date(),
          "yymm",
        )}`,
        rw_number_text: `RW${d.project_number}${format_date(
          new Date(),
          "yymm",
        )}`,
        meter_convergence: toFixed(toNum(d.meter_convergence)),
        equipment_maintenance_fee: toFixed(toNum(d.equipment_maintenance_fee)),
        common_expenses: toFixed(toNum(d.common_expenses)),
        common_expenses_type: d.common_expenses_type ? "1" : "0",
        waste_cost: toFixed(toNum(d.waste_cost)),
        cable_cost: toFixed(toNum(d.cable_cost)),
        add_debt: toFixed(toNum(d.add_debt)),
        reduce_debt: toFixed(toNum(d.reduce_debt)),
        water_charge_start: toNum(d.water_charge.water_charge_start),
        water_charge_end: toNum(d.water_charge.water_charge_end),
        water_charge_price: toFixed(toNum(d.water_charge.water_charge_price)),
        water_calculate_type: Number(d.water_calculate_type) || 2,
        fire_cost: toFixed(toNum(d.fire_cost)),
        penalty_day_list: d.penalty_day_list.length ? d.penalty_day_list : [""],
        penalty_month_list: d.penalty_month_list.length
          ? d.penalty_month_list.map((i) => ({
              month_start: Number(i.month_start),
              month_end: Number(i.month_end),
              penalty_year_rate: toFixed(toNum(i.penalty_year_rate)),
            }))
          : [{ month_start: "", month_end: "", penalty_year_rate: "0.00" }],
        water_rate_list: d.water_rate_list.length
          ? d.water_rate_list.map((i) => ({
              water_rate_start: Number(i.water_rate_start),
              water_rate_end: Number(i.water_rate_end),
              water_rate_price: toFixed(toNum(i.water_rate_price)),
            }))
          : [
              {
                water_rate_start: 0.0,
                water_rate_end: 0.0,
                water_rate_price: "0.00",
              },
            ],
        water_bill_text: d.water_bill_text || "ค่าน้ำประปา",
        meter_connect_cost_text: d.meter_connect_cost_text || "ค่าต่อมิเตอร์",
        equipment_maintenance_fee_text:
          d.equipment_maintenance_fee_text || "ค่าบริการอุปกรณ์",
        waste_cost_text: d.waste_cost_text || "ค่าขยะ",
        common_expenses_text: d.common_expenses_text || "ค่าส่วนกลาง",
        fire_cost_text: d.fire_cost_text || "ค่าเบี้ยประกัน",
        cable_cost_text: d.cable_cost_text || "ค่าเคเบิล",
      });
    }
  };

  Update = async () => {
    const reqFields = [
      "payment_close_time",
      "meter_cut_date",
      "meter_cut_month",
      "equipment_maintenance_fee",
      "common_expenses",
      "waste_cost",
      "cable_cost",
      "payment_deadline",
      "water_charge_start",
      "water_charge_end",
      "water_charge_price",
      "penalty_day_list",
      "penalty_month_list",
      "water_rate_list",
    ];
    if (
      validate(this.state, reqFields) ||
      this.state.payment_deadline == 0 ||
      (this.state.penalty_day_list && this.state.penalty_day_list[0] === "")
    ) {
      return alert("warning", "แจ้งเตือน", "กรุณากรอกข้อมูลให้ครบถ้วน");
    }

    let arr = [this.state.water_charge_end];
    for (let w of this.state.water_rate_list) {
      for (let i = w.water_rate_start; i <= w.water_rate_end; i++) {
        if (arr.includes(i))
          return alert("warning", "แจ้งเตือน", "อัตราการจัดเก็บค่าน้ำซ้ำกัน");
        arr.push(i);
      }
    }

    loading(true);
    let s = this.state;
    let data = {
      ...s,
      iw_running: s.iw_running ? s.iw_number_text + s.iw_running : "",
      rw_running: s.rw_running ? s.rw_number_text + s.rw_running : "",
      interest_adjustment: toNum(s.interest_adjustment),
      meter_convergence: toNum(s.meter_convergence),
      equipment_maintenance_fee: toNum(s.equipment_maintenance_fee),
      common_expenses: toNum(s.common_expenses),
      common_expenses_type: s.common_expenses_type === "1",
      waste_cost: toNum(s.waste_cost),
      cable_cost: toNum(s.cable_cost),
      add_debt: toNum(s.add_debt),
      reduce_debt: toNum(s.reduce_debt),
      fire_cost: toFixed(toNum(s.fire_cost)),
      payment_deadline: s.payment_deadline || "0",
      water_charge_start: toNum(s.water_charge_start),
      water_charge_end: toNum(s.water_charge_end),
      water_charge_price: toNum(s.water_charge_price),
      water_calculate_type: Number(s.water_calculate_type) || 2,
      penalty_day_list: s.penalty_day_list.filter((i) => i !== "").map(Number),
      penalty_month_list: s.penalty_month_list
        .filter(
          (i) =>
            i.month_start !== "" &&
            i.month_end !== "" &&
            i.penalty_year_rate !== "",
        )
        .map((i) => ({
          month_start: Number(i.month_start),
          month_end: Number(i.month_end),
          penalty_year_rate: Number(i.penalty_year_rate),
        })),
      water_rate_list: s.water_rate_list
        .filter(
          (i) =>
            i.water_rate_start !== 0 &&
            i.water_rate_end !== 0 &&
            i.water_rate_price !== 0,
        )
        .map((i) => ({
          water_rate_start: Number(i.water_rate_start),
          water_rate_end: Number(i.water_rate_end),
          water_rate_price: Number(i.water_rate_price),
        })),
      start_balance_statement: toNum(s.start_balance_statement),
      start_date_statement: s.start_date_statement || null,
    };

    let r = await PUT(tokens, "v1/TH/water-manage/update", data);
    if (r?.status) {
      success();
      await Promise.all([
        this.GetById(),
        this.GetDocNumber("IW"),
        this.GetDocNumber("RW"),
      ]);
    }
    loading(false);
  };

  updatePenaltyMonth = (idx, key, val) => {
    if (!float(val)) return;
    let list = [...this.state.penalty_month_list];
    list[idx][key] = val;

    let s = Number(list[idx].month_start),
      e = Number(list[idx].month_end);
    if (
      s &&
      e &&
      s >= e &&
      e !== 999 &&
      (key === "month_start" || key === "month_end")
    ) {
      return alert(
        "warning",
        "แจ้งเตือน",
        "ไม่สามารถเลือกเดือนเริ่มต้นมากกว่าหรือเท่ากับเดือนสิ้นสุดได้",
      );
    }

    let arr = Array(12).fill(0);
    for (let p of list) {
      let ms = Number(p.month_start),
        me = Number(p.month_end) || ms;
      if (ms) for (let i = ms; i <= Math.min(me, 12); i++) arr[i - 1]++;
    }
    if (arr.some((v) => v > 1))
      return alert("warning", "แจ้งเตือน", "ไม่สามารถเลือกเดือนซ้ำกันได้");

    this.setState({ penalty_month_list: list });
  };

  // ขอสิทธิ์การแก้ไขข้อมูล ปลดล็อกช่องรูปแบบการคำนวณค่าน้ำ (ใช้ endpoint เดียวกับหน้า /record-receipt)
  updatePermission = async () => {
    loading(true);
    let result = await POST(tokens, "v1/TH/record-receipt/check-box-confirm", {
      username: this.state.username,
      password: this.state.password,
    });
    if (result?.status)
      this.setState({ editable_calculate_type: true, modal_permission: false });
    loading(false);
    this.setState({ username: "", password: "" });
  };

  inp = (lbl, key, isFloat = true, onBlr = false, extraProps = {}) => (
    <div className="col-12 col-sm-6 mb-2">
      <label>{lbl}</label>
      <input
        type="text"
        className="form-control bg-contain border-0 mx-1"
        placeholder="พิมพ์คำค้นหา..."
        value={this.state[key]}
        onChange={(e) => {
          if (!isFloat || float(e.target.value))
            this.setState({ [key]: e.target.value });
        }}
        onBlur={() =>
          onBlr && this.setState({ [key]: toFixed(toNum(this.state[key])) })
        }
        {...extraProps}
      />
    </div>
  );

  txtInp = (lbl, key) => (
    <div className="col-12 col-sm-6 mb-2">
      <label>{lbl}</label>
      <input
        type="text"
        className="form-control w-100"
        placeholder={lbl}
        value={this.state[key]}
        onChange={(e) => this.setState({ [key]: e.target.value })}
      />
    </div>
  );

  render() {
    const s = this.state;
    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ตั้งค่า" page3="จัดการอัตราค่าน้ำ" />
        <div className="body">
          <div className="px-3 pt-3 pb-5">
            <div className="card border-0 bg-gray p-3 mb-3">
              <h4 className="mb-0">
                <b>จัดการข้อมูลระบบน้ำประปา</b>
              </h4>
            </div>
            <div className="card border-0 px-3 pt-3 mb-3">
              <div className="row">
                <div className="col-12 col-sm-6 col-md-4 col-lg-5 col-xl-3">
                  <label>หมายเลขโครงการบ้านเอื้ออาทร:</label>
                  <input
                    type="text"
                    className="form-control bg-contain border-0 mx-1 mb-2"
                    readOnly
                    value={s.project_number}
                  />
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-5 col-xl-3">
                  <label>ชื่อโครงการ</label>
                  <input
                    type="text"
                    className="form-control bg-contain border-0 mx-1 mb-2"
                    readOnly
                    value={s.project_name}
                  />
                </div>
              </div>
            </div>

            <div className="card border-0 bg-gray p-3 mb-3">
              <h4 className="mb-0">
                <b>ระบบการจัดเก็บค่าน้ำ</b>
              </h4>
            </div>
            <div className="card border-0 px-3 pt-3 mb-3">
              <div className="row">
                <div className="col-12 col-sm-6 mb-2">
                  <label>ค่าเริ่มต้นหมายเลข IW</label>
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control bg-contain border-0"
                      maxLength={4}
                      onChange={(e) =>
                        float(e.target.value) &&
                        this.setState({ iw_running: e.target.value })
                      }
                      value={s.iw_running}
                      style={{ paddingLeft: 95 }}
                      disabled={s.iw_status}
                    />
                    <label
                      className="position-absolute"
                      style={{ left: 12, top: 12 }}
                    >
                      {s.iw_number_text}
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-6 mb-2">
                  <label>ค่าเริ่มต้นหมายเลข RW</label>
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control bg-contain border-0"
                      maxLength={2}
                      onChange={(e) =>
                        float(e.target.value) &&
                        this.setState({ rw_running: e.target.value })
                      }
                      value={s.rw_running}
                      style={{ paddingLeft: 100 }}
                      disabled={s.rw_status}
                    />
                    <label
                      className="position-absolute"
                      style={{ left: 12, top: 12 }}
                    >
                      {s.rw_number_text}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="card border-0 px-3 pt-3 mb-3">
              <div className="row">
                <div className="col-12 col-sm-3 mb-2">
                  <label>จำนวนเดือนก่อนตัดมิเตอร์:</label>
                  <select
                    className="form-control bg-contain border-0"
                    value={s.meter_cut_month}
                    onChange={(e) =>
                      this.setState({ meter_cut_month: e.target.value })
                    }
                  >
                    {MONTHS.slice(0, 7).map((m) => (
                      <option key={m} value={m}>
                        {m}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-12 col-sm-3 mb-2">
                  <label>วันที่ตัดมิเตอร์:</label>
                  <select
                    className="form-control bg-contain border-0"
                    value={s.meter_cut_date}
                    onChange={(e) =>
                      this.setState({ meter_cut_date: e.target.value })
                    }
                  >
                    {DAYS.map((d) => (
                      <option key={d} value={d}>
                        {d}
                      </option>
                    ))}
                  </select>
                </div>
                {this.inp("ค่าบรรจบมาตร", "meter_convergence", true, true)}
              </div>
            </div>

            <div className="card border-0 px-3 pt-3 mb-3">
              <label>กำหนดวันที่ในการคำนวนเบี้ยปรับ (ในรอบเดือน)</label>
              {s.penalty_day_list.map((item, idx) => (
                <div key={idx} className="d-flex align-items-center mb-2">
                  <div className="w-100 mr-2">
                    <select
                      className="form-control bg-contain border-0"
                      value={item}
                      onChange={(e) => {
                        if (
                          s.penalty_day_list.some(
                            (p) => Number(p) === Number(e.target.value),
                          )
                        )
                          return alert(
                            "warning",
                            "แจ้งเตือน",
                            "วันที่ในการคำนวนเบี้ยปรับแล้ว",
                          );
                        let list = [...s.penalty_day_list];
                        list[idx] = e.target.value;
                        this.setState({ penalty_day_list: list });
                      }}
                    >
                      {DAYS.map((d) => (
                        <option key={d} value={d}>
                          {d}
                        </option>
                      ))}
                    </select>
                  </div>
                  {s.penalty_day_list.length > 1 && (
                    <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex justify-content-center align-items-center mr-2">
                      <label
                        className="icon mx-2 text-danger pointer"
                        onClick={() => {
                          let l = [...s.penalty_day_list];
                          l.splice(idx, 1);
                          this.setState({ penalty_day_list: l });
                        }}
                      >
                        {"\uf2ed"}
                      </label>
                    </label>
                  )}
                  {idx + 1 === s.penalty_day_list.length && (
                    <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-flex justify-content-center align-items-center">
                      <label
                        className="text-24 mx-2 text-primary pointer"
                        onClick={() =>
                          this.setState({
                            penalty_day_list: [...s.penalty_day_list, ""],
                          })
                        }
                      >
                        +
                      </label>
                    </label>
                  )}
                </div>
              ))}
            </div>

            <div className="card border-0 px-3 pt-3 mb-3">
              <div className="row">
                <div className="col-12 col-sm-6 mb-2">
                  <label>วันสิ้นสุดการชำระ</label>
                  <select
                    className="form-control bg-contain border-0"
                    value={s.payment_deadline}
                    onChange={(e) =>
                      this.setState({ payment_deadline: e.target.value })
                    }
                  >
                    {DAYS.map((d) => (
                      <option key={d} value={d}>
                        {d}
                      </option>
                    ))}
                  </select>
                </div>
                {this.inp(
                  "เวลาปิดรับชำระ",
                  "payment_close_time",
                  false,
                  false,
                  { type: "time" },
                )}
              </div>
              {s.penalty_month_list.map((item, idx) => (
                <div key={idx} className="row">
                  <div className="col-12 col-sm-6 mb-2">
                    <label>เงื่อนไขในการคิดเบี้ยปรับ (เดือน)</label>
                    <div className="w-100 d-flex align-items-center">
                      <select
                        className="form-control bg-contain border-0 mx-1"
                        value={item.month_start}
                        onChange={(e) =>
                          this.updatePenaltyMonth(
                            idx,
                            "month_start",
                            e.target.value,
                          )
                        }
                      >
                        {MONTHS.map((m) => (
                          <option key={m} value={m}>
                            {m}
                          </option>
                        ))}
                      </select>
                      <label className="mb-0 mx-3">ถึง</label>
                      <select
                        className="form-control bg-contain border-0 mx-1"
                        value={item.month_end}
                        onChange={(e) =>
                          this.updatePenaltyMonth(
                            idx,
                            "month_end",
                            e.target.value,
                          )
                        }
                      >
                        {MONTHS.map((m) => (
                          <option key={m} value={m}>
                            {m}
                          </option>
                        ))}
                        <option value="999">ไม่สิ้นสุด</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 mb-2">
                    <label>เบี้ยปรับ (ต่อปี)</label>
                    <div className="w-100 d-flex align-items-center">
                      <div className="w-100 position-relative">
                        <input
                          type="text"
                          className="form-control bg-contain border-0 mx-1 pr-5"
                          value={item.penalty_year_rate}
                          onChange={(e) =>
                            float(e.target.value) &&
                            this.setState({
                              penalty_month_list: s.penalty_month_list.map(
                                (p, i) =>
                                  i === idx
                                    ? {
                                        ...p,
                                        penalty_year_rate: e.target.value,
                                      }
                                    : p,
                              ),
                            })
                          }
                          onBlur={() =>
                            this.setState({
                              penalty_month_list: s.penalty_month_list.map(
                                (p, i) =>
                                  i === idx
                                    ? {
                                        ...p,
                                        penalty_year_rate: toFixed(
                                          toNum(p.penalty_year_rate),
                                        ),
                                      }
                                    : p,
                              ),
                            })
                          }
                        />
                        <span
                          className="mx-2 position-absolute"
                          style={{ right: 12, top: 10 }}
                        >
                          %
                        </span>
                      </div>
                      {s.penalty_month_list.length > 1 && (
                        <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex justify-content-center align-items-center mr-2">
                          <label
                            className="icon mx-2 text-danger pointer"
                            onClick={() => {
                              let l = [...s.penalty_month_list];
                              l.splice(idx, 1);
                              this.setState({ penalty_month_list: l });
                            }}
                          >
                            {"\uf2ed"}
                          </label>
                        </label>
                      )}
                      {idx + 1 === s.penalty_month_list.length && (
                        <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-flex justify-content-center align-items-center">
                          <label
                            className="text-24 mx-2 text-primary pointer"
                            onClick={() =>
                              this.setState({
                                penalty_month_list: [
                                  ...s.penalty_month_list,
                                  {
                                    month_start: "",
                                    month_end: "",
                                    penalty_year_rate: 0.0,
                                  },
                                ],
                              })
                            }
                          >
                            +
                          </label>
                        </label>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="card border-0 px-3 pt-3 mb-3">
              <div className="row">
                <div className="col-12 col-sm-6 mb-2">
                  <label>รูปแบบการคำนวณค่าน้ำ</label>
                  <div className="w-100 d-flex align-items-center">
                    <select
                      className="form-control bg-contain border-0 mx-1"
                      value={s.water_calculate_type}
                      disabled={!s.editable_calculate_type}
                      onChange={(e) =>
                        this.setState({
                          water_calculate_type: Number(e.target.value),
                        })
                      }
                    >
                      <option value={1}>แบบขั้นบันไดตั้งแต่ขั้นที่ 3</option>
                      <option value={2}>แบบขั้นบันไดแท้</option>
                      <option value={3}>แบบเหมารวม</option>
                    </select>
                    {create_r && !s.editable_calculate_type && (
                      <button
                        className="btn btn-outline-primary text-nowrap px-3 mx-1"
                        onClick={() => this.setState({ modal_permission: true })}
                      >
                        แก้ไข
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-sm-6 mb-2">
                  <label>อัตราการจัดเก็บค่าน้ำขั้นต่ำ (หน่วย)</label>
                  <div className="w-100 d-flex align-items-center">
                    <input
                      type="text"
                      className="form-control bg-contain border-0 mx-1"
                      value={s.water_charge_start}
                      onChange={(e) =>
                        float(e.target.value) &&
                        this.setState({
                          water_charge_start: Number(e.target.value),
                        })
                      }
                    />
                    <label className="mb-0 mx-3">ถึง</label>
                    <input
                      type="text"
                      className="form-control bg-contain border-0 mx-1"
                      value={s.water_charge_end}
                      onChange={(e) =>
                        float(e.target.value) &&
                        this.setState({
                          water_charge_end: Number(e.target.value),
                        })
                      }
                    />
                  </div>
                </div>
                {this.inp("ราคา (บาท)", "water_charge_price", true, true)}
              </div>
              {s.water_rate_list.map((item, idx) => (
                <div key={idx} className="row">
                  <div className="col-12 col-sm-6 mb-2">
                    <label>อัตราการจัดเก็บค่าน้ำ (หน่วย)</label>
                    <div className="w-100 d-flex align-items-center">
                      <input
                        type="text"
                        className="form-control bg-contain border-0 mx-1"
                        value={item.water_rate_start}
                        onChange={(e) =>
                          float(e.target.value) &&
                          this.setState({
                            water_rate_list: s.water_rate_list.map((w, i) =>
                              i === idx
                                ? {
                                    ...w,
                                    water_rate_start: Number(e.target.value),
                                  }
                                : w,
                            ),
                          })
                        }
                      />
                      <label className="mb-0 mx-3">ถึง</label>
                      <input
                        type="text"
                        className="form-control bg-contain border-0 mx-1"
                        value={item.water_rate_end}
                        onChange={(e) =>
                          float(e.target.value) &&
                          this.setState({
                            water_rate_list: s.water_rate_list.map((w, i) =>
                              i === idx
                                ? {
                                    ...w,
                                    water_rate_end: Number(e.target.value),
                                  }
                                : w,
                            ),
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 mb-2">
                    <label>ราคา (บาท/หน่วย)</label>
                    <div className="w-100 d-flex align-items-center">
                      <input
                        type="text"
                        className="form-control bg-contain border-0 mx-1"
                        value={item.water_rate_price}
                        onChange={(e) =>
                          float(e.target.value) &&
                          this.setState({
                            water_rate_list: s.water_rate_list.map((w, i) =>
                              i === idx
                                ? { ...w, water_rate_price: e.target.value }
                                : w,
                            ),
                          })
                        }
                        onBlur={() =>
                          this.setState({
                            water_rate_list: s.water_rate_list.map((w, i) =>
                              i === idx
                                ? {
                                    ...w,
                                    water_rate_price: toFixed(
                                      toNum(w.water_rate_price),
                                    ),
                                  }
                                : w,
                            ),
                          })
                        }
                      />
                      {s.water_rate_list.length > 1 && (
                        <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex justify-content-center align-items-center mr-2">
                          <label
                            className="icon mx-2 text-danger pointer"
                            onClick={() => {
                              let l = [...s.water_rate_list];
                              l.splice(idx, 1);
                              this.setState({ water_rate_list: l });
                            }}
                          >
                            {"\uf2ed"}
                          </label>
                        </label>
                      )}
                      {idx + 1 === s.water_rate_list.length && (
                        <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-flex justify-content-center align-items-center">
                          <label
                            className="text-24 mx-2 text-primary pointer"
                            onClick={() =>
                              this.setState({
                                water_rate_list: [
                                  ...s.water_rate_list,
                                  {
                                    water_rate_start: 0.0,
                                    water_rate_end: 0.0,
                                    water_rate_price: "0.00",
                                  },
                                ],
                              })
                            }
                          >
                            +
                          </label>
                        </label>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="card border-0 bg-gray p-3 mb-3">
              <h4 className="mb-0">
                <b>ค่าใช้จ่ายอื่น ๆ</b>
              </h4>
            </div>
            <div className="card border-0 px-3 pt-3 mb-5">
              <div className="row">
                {this.inp(
                  "ค่ารักษาอุปกรณ์ (บาท)",
                  "equipment_maintenance_fee",
                  true,
                  true,
                )}
                <div className="col-12 col-sm-3 mb-2">
                  <label>ประเภทค่าใช้จ่ายส่วนกลาง</label>
                  <select
                    className="form-control bg-contain border-0 mx-1"
                    value={s.common_expenses_type}
                    onChange={(e) =>
                      this.setState({ common_expenses_type: e.target.value })
                    }
                  >
                    <option value="0">จำนวนเต็ม</option>
                    <option value="1">คำนวณตามพื้นที่ห้อง</option>
                  </select>
                </div>
                {this.inp(
                  s.common_expenses_type === "0"
                    ? "ค่าใช้จ่ายส่วนกลาง (บาท)"
                    : "ค่าใช้จ่ายส่วนกลาง (บาท) / ตรม.",
                  "common_expenses",
                  true,
                  true,
                )}
                {this.inp("ค่าขยะ (บาท)", "waste_cost", true, true)}
                {this.inp("ค่าเคเบิล (บาท)", "cable_cost", true, true)}
                {this.inp(
                  "ค่าเบี้ยประกันอัคคีภัย (บาท)",
                  "fire_cost",
                  true,
                  true,
                )}
                <div className="col-12 col-sm-6"></div>
                <div className="col-12 col-sm-6 mb-2">
                  <label>เดือนที่คิดค่าเบี้ยประกันอัคคีภัย:</label>
                  <select
                    className="form-control bg-contain border-0 mx-1"
                    value={s.fire_month}
                    onChange={(e) =>
                      this.setState({ fire_month: e.target.value })
                    }
                  >
                    {MONTHS.map((m) => (
                      <option key={m} value={m}>
                        {m}
                      </option>
                    ))}
                  </select>
                </div>
                {this.inp("เพิ่มหนี้ (บาท)", "add_debt", true, true)}
                {this.inp("ลดหนี้ (บาท)", "reduce_debt", true, true)}
              </div>
            </div>

            <div className="card border-0 bg-gray p-3 mb-3">
              <h4 className="mb-0">
                <b>รายการ Statement</b>
              </h4>
            </div>
            <div className="card border-0 px-3 pt-3 mb-5">
              <div className="row">
                <div className="col-12 col-sm-6 mb-2">
                  <label>วัน/เดือน/ปีเริ่มต้น</label>
                  <DatePicker
                    className="form-control w-100"
                    value={s.start_date_statement}
                    onChange={(e) => this.setState({ start_date_statement: e })}
                  />
                </div>
                {this.inp(
                  "ยอดเงิน statement เริ่มต้น",
                  "start_balance_statement",
                  true,
                  false,
                )}
              </div>
            </div>

            <div className="card border-0 bg-gray p-3 mb-3">
              <h4 className="mb-0">
                <b>ข้อความระบบ</b>
              </h4>
            </div>
            <div className="card border-0 px-3 pt-3 mb-5">
              <div className="row">
                {this.txtInp("ค่าน้ำประปา", "water_bill_text")}
                {this.txtInp("ค่าต่อมิเตอร์", "meter_connect_cost_text")}
                {this.txtInp(
                  "ค่าบริการอุปกรณ์",
                  "equipment_maintenance_fee_text",
                )}
                {this.txtInp("ค่าขยะ", "waste_cost_text")}
                {this.txtInp("ค่าส่วนกลาง", "common_expenses_text")}
                {this.txtInp("ค่าเบี้ยประกัน", "fire_cost_text")}
                {this.txtInp("ค่าเคเบิล", "cable_cost_text")}
                <div className="col-12 col-sm-6 mb-2">
                  <div className="text-white">A</div>
                  <button
                    className="btn btn-primary px-3"
                    onClick={() =>
                      this.setState({
                        water_bill_text: "ค่าน้ำประปา",
                        meter_connect_cost_text: "ค่าต่อมิเตอร์",
                        equipment_maintenance_fee_text: "ค่าบริการอุปกรณ์",
                        waste_cost_text: "ค่าขยะ",
                        common_expenses_text: "ค่าส่วนกลาง",
                        fire_cost_text: "ค่าเบี้ยประกัน",
                        cable_cost_text: "ค่าเคเบิล",
                      })
                    }
                  >
                    รีเซ็ตค่าเริ่มต้น
                  </button>
                </div>
              </div>
            </div>

            <div className="card border-0 bg-gray p-3 mb-3">
              <h4 className="mb-0">
                <b>รับชำระค่าใช้จ่าย</b>
              </h4>
            </div>
            <div className="card border-0 px-3 pt-3 mb-5">
              <div className="row">
                <div className="col-12 col-sm-6 mb-2">
                  <label>การบังคับ อัปโหลดรูปสลิปเงินโอน</label>
                  <br />
                  <Switch
                    height={20}
                    width={40}
                    checked={s.is_upload_slip}
                    onChange={(e) => this.setState({ is_upload_slip: e })}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {create_r && (
          <div
            className="body px-3 pt-3 bg-white position-fixed"
            style={{ bottom: 0 }}
          >
            <div className="row mx-0">
              <div className="ml-auto col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 px-2 mb-3">
                <button
                  className="btn btn-outline-primary w-100"
                  onClick={() => window.location.reload()}
                >
                  ยกเลิก
                </button>
              </div>
              <div className="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2 px-2 mb-3">
                <button className="btn btn-primary w-100" onClick={this.Update}>
                  บันทึก
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ขอสิทธิ์การแก้ไขข้อมูล ก่อนแก้รูปแบบการคำนวณค่าน้ำ */}
        <Modal
          show={s.modal_permission}
          onHide={() => this.setState({ modal_permission: false })}
        >
          <Modal.Header>
            <Modal.Title>
              <b>ขอสิทธิ์การแก้ไขข้อมูล</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex align-items-center mb-3">
              <label className="wpx-140">ชื่อผู้ใช้งาน{required}:</label>
              <input
                className="form-control border-0 bg-contain validate"
                type="text"
                onChange={(e) => this.setState({ username: e.target.value })}
                value={s.username}
              />
            </div>
            <div className="w-100 d-flex align-items-center mb-3">
              <label className="wpx-140">รหัสผ่าน{required}:</label>
              <input
                className="form-control border-0 bg-contain validate"
                type="password"
                onChange={(e) => this.setState({ password: e.target.value })}
                value={s.password}
              />
            </div>
            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button
                  className="btn btn-outline-primary w-100"
                  onClick={() => this.setState({ modal_permission: false })}
                >
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button
                  className="btn btn-primary w-100"
                  onClick={this.updatePermission}
                >
                  ยืนยัน
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
